












































































































































































































import Vue from "vue";
import { ComboBox } from "@progress/kendo-vue-dropdowns";
import createPagerText from "@/utils/pagerText";


interface Data{
    item: any;
    opened: boolean;
    currentPageSize: number;
    currentPageNumber: number;
    filter: string;
    firstPageNumberButtonVisible: boolean;
    firstPageNumberButtonValue: number;
    secondPageNumberButtonVisible: boolean;
    secondPageNumberButtonValue: number;
    thirdPageNumberButtonVisible: boolean;
    thirdPageNumberButtonValue: number;
    fourthPageNumberButtonVisible: boolean;
    fourthPageNumberButtonValue: number;
    fifthPageNumberButtonVisible: boolean;
    fifthPageNumberButtonValue: number;
    localItems: any[];
    isSelecting: boolean;
    selectOnMouseUp: boolean;
}

interface Method{
    onItemCleared(): void;
    searchClick(item: object): void;
    searchChanged(event: any): void;
    setCurrentPageNumber(pageNumber: number): void;
    setCurrentPageSize(pageSize: number): void;
    decrementPageNumber(): void;
    incrementPageNumber(): void;
    onComboOpen(): void;
    onComboClose(): void;
    setPageNumbers(): void;
    onKeyDown(e: any): void;
    onInputFocus(): void;
    onInputMouseUp(e: any): void;
}

interface Computed{
    footerText: string;
    maxPageNumber: number;
    displayedItems: object[];
}
interface Props {
    columns: string[];
    fields: string[];
    items: object[];
    textField: string;
    selectedElement: string;
    disabled: boolean;
    dataItemKey: string;
}

export default Vue.extend<Data, Method, Computed, Props>({
    components: 
    { 
        ComboBox 
    },
    data(){
        return{
            item: null,
            opened: false,
            currentPageSize: 10,
            currentPageNumber: 1,
            filter: "",
            localItems: [],
            selectOnMouseUp: false,
            firstPageNumberButtonVisible: true,
            firstPageNumberButtonValue: 1,
            secondPageNumberButtonVisible: true,
            secondPageNumberButtonValue: 2,
            thirdPageNumberButtonVisible: true,
            thirdPageNumberButtonValue: 3,
            fourthPageNumberButtonVisible: true,
            fourthPageNumberButtonValue: 4,
            fifthPageNumberButtonVisible: true,
            fifthPageNumberButtonValue: 5,
            isSelecting: false,
        }
    },
    methods:{
        // A Kendo ComboBox natív "×" törlés-gombja a v-model-en (this.item) keresztül null-ra
        // állítja az értéket, de ezt maga a Kendo-komponens NEM emit-eli kifelé — enélkül a szülő
        // sosem értesül a törlésről, a szűrő/mező értéke "ragad" (H-12). A watcher csak ERRE az
        // egy esetre reagál (newVal üres/null); a searchClick (isSelecting guard) és az onKeyDown
        // (nem írja át this.item-et) útjait nem érinti, tehát nincs dupla emit.
        // Biztonságos, {textField: ""} alakú (SOSEM null) payloadot küldünk, mert számos fogyasztó
        // (pl. TransactionItemEdit.onCarValueChanged/onAccNoValueChanged) newValue.id/.dimcode-ot
        // olvas null-ellenőrzés nélkül — egy sima null payload ott futásidejű hibát dobna.
        onItemCleared(): void {
            if (this.isSelecting) return;
            const cleared = { [this.textField]: "" };
            this.$emit("update:selectedElement", cleared);
            this.$emit("change", cleared);
        },
        async searchClick(item: object ) {
            this.isSelecting = true;
            this.item = item;

            // const combo = this.$refs.combo as any;
            // combo.input.dispatchEvent(new Event("input"));

            this.$emit("update:selectedElement", this.item);
            this.$emit('change', item);
            this.$nextTick(() => {
                this.isSelecting = false;
            });
            // this.$emit("value", this.item);
        },
        searchChanged(event){
            if (this.isSelecting)
                return;
            this.filter = event.filter.value;
            const q = this.filter.trim().toLowerCase();
            if (q !== "") {
                // A megjelenített mezők BÁRMELYIKÉRE illesztünk (nem csak a textField-re),
                // hogy a felhasználó arra kereshessen, amit a sorban lát (pl. megnevezés, rendszám).
                this.localItems = this.$props.items.filter((x: any) =>
                    this.fields.some((f) => (x[f] ?? "").toString().toLowerCase().includes(q)) ||
                    (x[this.textField] ?? "").toString().toLowerCase().includes(q)
                );
            } else {
                this.localItems = this.$props.items;
            }
            // Szűrés után az 1. oldalra állunk, különben a slice tartományon kívülre eshet.
            this.currentPageNumber = 1;
            this.setPageNumbers();
        },
        setCurrentPageNumber(pageNumber) {
            if (this.currentPageNumber == pageNumber) return;

            this.currentPageNumber = pageNumber;
        },
        setCurrentPageSize(pageSize) {
            if (this.currentPageSize == pageSize) return;

            this.currentPageSize = pageSize;
        },
        onComboOpen() {
            this.opened = true;
            this.localItems = this.$props.items;
            this.currentPageNumber = 1;
            this.setPageNumbers();
            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    const popupEl = document.querySelector<HTMLElement>('.k-animation-container');
                    const combo = this.$refs.combo as any;
                    if (!popupEl || !combo) return;

                    const listRect = popupEl.getBoundingClientRect();
                    const inputRect = combo.$refs.baseWrapper.getBoundingClientRect();
                    const screenWidth = window.innerWidth;
                    const screenHeight = window.innerHeight;

                    let translateX = 0;
                    let translateY = 0;

                    // Vízszintes: ha jobbra kilógna, balra húzzuk.
                    if (listRect.right > screenWidth) {
                        translateX = -(listRect.width - inputRect.width);
                    }

                    // Függőleges: ha lefelé nyitva a viewport aljából kilógna (azaz növelné az
                    // oldalt), ÉS felfelé van elég hely, akkor az input fölé toljuk -> felfelé nyílik.
                    if (listRect.bottom > screenHeight && inputRect.top > listRect.height) {
                        translateY = -(listRect.height + inputRect.height);
                    }

                    // Mindig beállítjuk (akár 0,0), hogy egy korábbi nyitás eltolása ne ragadjon ott.
                    popupEl.style.transform = `translate(${translateX}px, ${translateY}px)`;
                });
            });
        },
        onComboClose(){
            this.opened = false;
        },
        incrementPageNumber(){
            const maxPageNumber = Math.ceil(
                this.localItems.length / this.currentPageSize
            );
            if (this.currentPageNumber == maxPageNumber) return;

            this.currentPageNumber++;
        },
        decrementPageNumber(){
            if (this.currentPageNumber == 1) return;

            this.currentPageNumber--;
        },
        setPageNumbers() {
            if (this.currentPageNumber == 0) return;

            const maxPageNumber = Math.ceil(
                this.localItems.length / this.currentPageSize
            );
            if (maxPageNumber <= 5) {
                this.firstPageNumberButtonVisible = false;
                this.secondPageNumberButtonVisible = false;
                this.thirdPageNumberButtonVisible = false;
                this.fourthPageNumberButtonVisible = false;
                this.fifthPageNumberButtonVisible = false;

            if (maxPageNumber >= 1) {
            this.firstPageNumberButtonVisible = true;
            this.firstPageNumberButtonValue = 1;
            }

            if (maxPageNumber >= 2) {
            this.secondPageNumberButtonVisible = true;
            this.secondPageNumberButtonValue = 2;
            }

            if (maxPageNumber >= 3) {
            this.thirdPageNumberButtonVisible = true;
            this.thirdPageNumberButtonValue = 3;
            }

            if (maxPageNumber >= 4) {
            this.fourthPageNumberButtonVisible = true;
            this.fourthPageNumberButtonValue = 4;
            }

            if (maxPageNumber == 5) {
            this.fifthPageNumberButtonVisible = true;
            this.fifthPageNumberButtonValue = 5;
            }
            } else {
                this.firstPageNumberButtonVisible = true;
                this.secondPageNumberButtonVisible = true;
                this.thirdPageNumberButtonVisible = true;
                this.fourthPageNumberButtonVisible = true;
                this.fifthPageNumberButtonVisible = true;

            if (maxPageNumber - this.currentPageNumber < 5) {
            this.firstPageNumberButtonValue = maxPageNumber - 4;
            this.secondPageNumberButtonValue = maxPageNumber - 3;
            this.thirdPageNumberButtonValue = maxPageNumber - 2;
            this.fourthPageNumberButtonValue = maxPageNumber - 1;
            this.fifthPageNumberButtonValue = maxPageNumber;
            } else {
            if (this.currentPageNumber < 5) {
                this.firstPageNumberButtonValue = 1;
                this.secondPageNumberButtonValue = 2;
                this.thirdPageNumberButtonValue = 3;
                this.fourthPageNumberButtonValue = 4;
                this.fifthPageNumberButtonValue = 5;
            } else {
                this.firstPageNumberButtonValue = this.currentPageNumber - 2;
                this.secondPageNumberButtonValue = this.currentPageNumber - 1;
                this.thirdPageNumberButtonValue = this.currentPageNumber;
                this.fourthPageNumberButtonValue = this.currentPageNumber + 1;
                this.fifthPageNumberButtonValue = this.currentPageNumber + 2;
                }
            }
        }
        },
        onKeyDown(e){
            if (e.key === 'Enter') {
                this.$emit("update:selectedElement", this.item);
                this.$emit('change', this.item)
            }
            // console.log(e);
        },
        // Fókuszra a teljes tartalom kijelölése: az első leütés így LECSERÉLI a régi értéket
        // (a "-" placeholdert és a korábbi kiválasztást is) — enélkül a gépelés hozzáfűz
        // ("-9211") és a keresés találat nélkül marad.
        onInputFocus(){
            const input = (this.$refs.combo as any)?.$el?.querySelector('input');
            if (!input) return;
            this.selectOnMouseUp = true;
            input.select();
        },
        // A fókuszt adó kattintás mouseup-ja alapból szétszedné a kijelölést — egyszer elnyeljük.
        // A második kattintás már normál kurzor-pozicionálás, így a szövegen belüli szerkesztés megmarad.
        onInputMouseUp(e){
            if (this.selectOnMouseUp) {
                e.preventDefault();
                this.selectOnMouseUp = false;
            }
        }
    },
    props:{
        columns:{ type: Array as () => string[], default: () => [] },
        items: {type: Array as () => object[], default: () => []},
        fields: { type: Array as () => string[], default: () => [] },
        textField: { type: String, default: '' },
        selectedElement: { type: String, default: '' },
        disabled: { type: Boolean, default: false },
        // Sor-kulcs a kijelöléshez; alapból a textField — ha a szöveges érték nem egyedi (pl. azonos kódú
        // összepontozás-csoportok), egy egyedi mezőt (pl. 'id') kell megadni, különben minden egyező sor kijelölt
        dataItemKey: { type: String, default: '' }
    },
    computed:{
        footerText() {
            return createPagerText(
                this.localItems.length,
                this.currentPageNumber,
                this.currentPageSize,
            );
        },
        maxPageNumber() {
            return Math.ceil(this.localItems.length / this.currentPageSize);
        },
        displayedItems() {
            return this.localItems.slice((this.currentPageNumber*this.currentPageSize)-this.currentPageSize,this.currentPageNumber*this.currentPageSize);
        },
    },
    mounted(){  
        this.item = {[this.textField]: this.$props.selectedElement != 'undefined' ? this.$props.selectedElement : "-"}
        this.setPageNumbers()
        const combo = this.$refs.combo;
        const input = (combo as any).$el.querySelector('input');
        if (input) {
            input.addEventListener('keydown', this.onKeyDown);
            input.addEventListener('focus', this.onInputFocus);
            input.addEventListener('mouseup', this.onInputMouseUp);
        }
    },
    beforeDestroy(){
        // A mounted-ban kézzel felvett listenerek leszedése, hogy ne szivárogjanak.
        const combo = this.$refs.combo as any;
        const input = combo?.$el?.querySelector('input');
        if (input) {
            input.removeEventListener('keydown', this.onKeyDown);
            input.removeEventListener('focus', this.onInputFocus);
            input.removeEventListener('mouseup', this.onInputMouseUp);
        }
    },
    watch:{
        currentPageNumber(){
            this.setPageNumbers();
        },
        // Csak a natív "×" törlés (Kendo v-model -> null) esetén fut le — kiválasztásnál
        // (searchClick) az isSelecting guard, gépelésnél/Enter-nél pedig az, hogy azok
        // nem null-ra állítják this.item-et, kizárja az újrafutást (nincs dupla emit).
        item(newVal) {
            if (!newVal) this.onItemCleared();
        },
        selectedElement(newVal) {
            const combo = this.$refs.combo as any;
            if(newVal != combo.input.value){
                combo.input.value = newVal;
                combo.input.dispatchEvent(new Event("input"));
                this.opened = false;
            }
        },
        items: {
            immediate: true,
            handler(val) {
                // Sekély másolat elég: a localItems-et csak szűrjük/szeleteljük, sosem mutáljuk helyben.
                this.localItems = Array.isArray(val) ? [...val] : [];
                this.currentPageNumber = 1;
                this.setPageNumbers();
            }
        }
    }
});
